import axios from 'axios';
import Bus from '@/assets/js/vueBus';
import Vue from 'vue';

window.v = new Vue();

let Tool = {
    getSession() {
        // let _str = '';
        const href = window.location.href;
        let keyIndex;
        const searchArrSession = href.split("?")[1];
        let searchArr = '';
        if (searchArrSession) {
            searchArr = searchArrSession.split("=");
        } else {
            // Bus.$emit("jumpLoginPage");
            return;
        }
        searchArr.map((item, index) => {
            if (item == "session") {
                keyIndex = index;
            }
        });
        const session = searchArr[keyIndex + 1];
        return session;
    },
    getQueryString(name, str, symbol) {
        str = (str == null ? window.location.search.substr(1) : str);
        symbol = (symbol == null ? "&" : symbol);
        var reg = new RegExp("(^|" + symbol + ")" + name + "=([^" + symbol + "]*)(" + symbol + "|$)", "i");
        var r = str.match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg); //匹配目标参数
        console.log(r)
        if (r != null) return unescape(r[2]);
        return null; //返回参数值
    },
    getSession() {
        // let _str = '';
        const href = window.location.href;
        let keyIndex;
        const searchArrSession = href.split("?")[1];
        let searchArr = '';
        if (searchArrSession) {
            searchArr = searchArrSession.split("=");
        } else {
            // Bus.$emit("jumpLoginPage");
            return;
        }
        searchArr.map((item, index) => {
            if (item == "session") {
                keyIndex = index;
            }
        });
        const session = searchArr[keyIndex + 1];
        return session;
    },
    //向localStorage中存取一些数据，第一个参数为存取什么，第二个参数是值。
    sgStorage(item, value) {
        if (arguments.length > 1) {
            if (localStorage.getItem(item) == null) {
                localStorage.setItem(item, value);
            } else if (value != localStorage.getItem(item) && value != undefined) {
                localStorage.setItem(item, value);
            }
        } else {
            return localStorage.getItem(item);
        }
    },
    getCookie(sName){
        let aCookie = document.cookie.split("; ");
        for (var i=0; i < aCookie.length; i++){
            var aCrumb = aCookie[i].split("=");
            if (sName == aCrumb[0])
            return decodeURIComponent(aCrumb[1]);
        }
        return null;
    }
}

export default Tool;
